<template>
    <div>
        <label for="code">
            <div class="flex-h flex-v-center flex-h-center">
                <div style="border-color: #EBEDF0 "
                     class="w-55 h-55 flex-h flex-h-center flex-v-center
                            border-w-1 radius-8 font-40 font-bold"
                     v-for="(item, index) in number" :key="index"
                     :class="{'margin-l-30':(index > 0),
                     'color-1477FE':(index === valueLength - 1),'color-0B0D08':index !== valueLength-1}">
                    <span>{{pinValue[index] ||placeholder}}</span>
                </div>
            </div>
        </label>
        <input ref="input"
               class="input-code"
               @keyup="handleInput($event)"
               v-model="value"
               id="code"
               name="code"
               type="tel"
               :maxlength="number"
               autocorrect="off"
               autocomplete="off"
               autocapitalize="off">
    </div>
</template>

<script>
    export default {
        name: "sms_code_square_input",
        props: {
            number: {
                type: Number,
                default: 4
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        // variables
        data() {
            return {
                value: '',
                pinValue: '',
                valueLength: 0,
            }
        },
        methods: {
            hideKeyboard() {
                // 输入完成隐藏键盘
                document.activeElement.blur() // ios隐藏键盘
                this.$refs.input.blur() // android隐藏键盘
            },
            handleSubmit() {
                this.valueLength = this.value.length;
                this.pinValue = '';
                for (let i = 0; i < this.valueLength; i++) {
                    this.pinValue += '•';
                }
                this.$emit('input', this.value)
            },
            handleInput() {
                this.$refs.input.value = this.value
                if (this.value.length >= this.number) {
                    this.hideKeyboard()
                }
                this.handleSubmit()
            }
        }
    }
</script>

<style scoped>

    .input-code {
        position: absolute;
        left: -9999px;
        top: -99999px;
        opacity: 0;
        overflow: visible;
        z-index: -1;
    }
</style>